export function isElementInViewport(element, startPercentage = 0, endPercentage = 1) {
    if (!element) {
        return false;
    }
    const bounding = element.getBoundingClientRect();
    if (!bounding) {
        return false;
    }
    const viewPortHeight = window.innerHeight || document.documentElement.clientHeight;
    const viewPortStart = viewPortHeight * startPercentage;
    const viewPortEnd = viewPortHeight * endPercentage;
    return (bounding.top >= viewPortStart && bounding.top <= viewPortEnd) ||
        (bounding.bottom >= viewPortStart && bounding.bottom <= viewPortEnd);
}
